import React from 'react';
import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { DropdownLabelProps } from './DropdownLabel';
import { IconArrowTriangleDown } from '../icons/generated';
import { semantic_colors } from '../../foundation';

interface DropdownArrowButtonProps extends DropdownLabelProps {
  colorProps?: string;
}

export const DropdownArrowButton = ({ expanded, disabled, colorProps, onClick }: DropdownArrowButtonProps) => {
  return (
    <ArrowButton onClick={onClick} aria-hidden>
      <IconArrowTriangleDown
        css={css`
          ${expanded && 'transform: rotate(180deg)'};
          cursor: ${disabled ? 'not-allowed' : 'pointer'};
        `}
        color={disabled ? semantic_colors.content.disabled : colorProps || semantic_colors.content.primary}
      />
    </ArrowButton>
  );
};

const ArrowButton = styled.div`
  flex: none;
  display: flex;
  justify-content: center;
  align-items: center;
`;
